module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "excel-up"
  }, [_c('input', {
    ref: "excel-upload-input",
    attrs: {
      "id": "excel-upload-input",
      "type": "file",
      "accept": ".xlsx, .xls"
    },
    on: {
      "change": _vm.handleClick
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "size": "mini",
      "type": "primary"
    }
  }, [_c('span', [_vm._v("导入中")]), _vm._v(" "), _c('span', {
    staticClass: "el-icon-loading"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-615e8b6b"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/components/excelRead/excel.vue
// module id = 1507
// module chunks = 1